import React, { useEffect, useState } from 'react';
import logo from '../../assets/icons/logo.svg';
import './header.css';
import theme from '../../assets/icons/themeIcon.svg';
import NavItem from '../common/navitem';
import { Link } from 'react-router-dom';
import HamburgerComp from './hamburger';
import { supabase } from '../../supabase';

const Header = () => {
    const [navLinks, setNavLinks] = useState([]);

    const loadNavLinks = async () => {
        const { data, error } = await supabase
            .from('navigation_links')
            .select('*')
            .eq('type', 'header')
            .eq('is_visible', true)
            .order('sort_order', { ascending: true });

        if (error) {
            console.error('Error loading navigation links:', error);
            return;
        }

        setNavLinks(data || []);
    };

    useEffect(() => {
        loadNavLinks();

        const channel = supabase
            .channel('header_navigation_changes')
            .on(
                'postgres_changes',
                {
                    event: '*',
                    schema: 'public',
                    table: 'navigation_links',
                },
                () => {
                    loadNavLinks();
                }
            )
            .subscribe();

        return () => {
            supabase.removeChannel(channel);
        };
    }, []);

    return (
        <>
            <header className='headerPadding'>
                <Link to="/" className='link'>
                    <img src={logo} alt="Cairo International Book Fair logo" />
                </Link>
                <a href="#main-content" className="skip-link">
                Skip to main content
                </a>

                <nav>
                    <ul>
                        {navLinks.map((link) => (
                            <NavItem
                                key={link.id}
                                navitemLocation={link.url}
                                navitem={link.label_en}
                            />
                        ))}
                    </ul>
                </nav>

                <HamburgerComp />

                <div className="headerControls">
                    <div className="headerControl">
                        <img src={theme} alt="Theme icon" />
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;